/**
 * Defer a callback until after the current frame (rAF + micro-delay). Replaces deprecated
 * `InteractionManager.runAfterInteractions` (RN warns; avoids touching InteractionManager at all).
 */
export function runAfterInteractions(callback: () => void): void {
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(() => {
      setTimeout(callback, 0);
    });
  } else {
    setTimeout(callback, 0);
  }
}
